import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const Hardware = () => {
  const products = [
    {
      icon: FiIcons.FiMonitor,
      title: 'Equipos de Sobremesa',
      description: 'Ordenadores personalizados para empresas con componentes de primeras marcas.'
    },
    {
      icon: FiIcons.FiMonitor,
      title: 'Portátiles',
      description: 'Equipos portátiles profesionales de las mejores marcas del mercado.'
    },
    {
      icon: FiIcons.FiServer,
      title: 'Servidores',
      description: 'Servidores empresariales configurados según sus necesidades específicas.'
    },
    {
      icon: FiIcons.FiPrinter,
      title: 'Periféricos',
      description: 'Impresoras, escáneres y otros dispositivos para su oficina.'
    }
  ];

  return (
    <div className="py-16 relative">
      <div className="max-w-7xl mx-auto px-4">
        <h1 className="text-4xl font-bold text-center mb-12">Hardware</h1>

        <div className="mb-12">
          <p className="text-lg text-gray-600 mb-6">
            Suministramos y configuramos equipos informáticos y componentes de las mejores marcas, adaptados a las necesidades específicas de su empresa.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {products.map((product, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-lg">
              <SafeIcon icon={product.icon} className="h-12 w-12 text-blue-600 mb-4" />
              <h3 className="text-xl font-semibold mb-2">{product.title}</h3>
              <p className="text-gray-600">{product.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-gray-50 p-8 rounded-lg">
          <h2 className="text-2xl font-semibold mb-6">Nuestro Proceso</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="bg-blue-600 rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-4">
                <SafeIcon icon={FiIcons.FiSearch} className="h-6 w-6 text-white" />
              </div>
              <h3 className="font-semibold mb-2">Análisis</h3>
              <p className="text-gray-600">Evaluación de necesidades</p>
            </div>
            <div className="text-center">
              <div className="bg-blue-600 rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-4">
                <SafeIcon icon={FiIcons.FiList} className="h-6 w-6 text-white" />
              </div>
              <h3 className="font-semibold mb-2">Propuesta</h3>
              <p className="text-gray-600">Selección de equipos</p>
            </div>
            <div className="text-center">
              <div className="bg-blue-600 rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-4">
                <SafeIcon icon={FiIcons.FiTool} className="h-6 w-6 text-white" />
              </div>
              <h3 className="font-semibold mb-2">Configuración</h3>
              <p className="text-gray-600">Preparación y pruebas</p>
            </div>
            <div className="text-center">
              <div className="bg-blue-600 rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-4">
                <SafeIcon icon={FiIcons.FiCheck} className="h-6 w-6 text-white" />
              </div>
              <h3 className="font-semibold mb-2">Entrega</h3>
              <p className="text-gray-600">Instalación y formación</p>
            </div>
          </div>
        </div>
      </div>

      {/* Botón para volver arriba */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="fixed bottom-6 right-6 bg-blue-600 text-white p-3 rounded-full shadow-lg hover:bg-blue-700 transition-all z-50"
        aria-label="Volver arriba"
      >
        <SafeIcon icon={FiIcons.FiArrowUp} className="h-6 w-6" />
      </button>
    </div>
  );
};

export default Hardware;